"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _reactDom = require("react-dom");

var _reactDom2 = _interopRequireDefault(_reactDom);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

var _customPropTypes = require("../helpers/customPropTypes");

var _newId = require("../helpers/newId");

var _newId2 = _interopRequireDefault(_newId);

require("./Modal.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// Modal sizes
var widthOptions = {
  small: "aclui-modal--small",
  medium: "aclui-modal--medium",
  large: "aclui-modal--large"
};

var Modal = function (_PureComponent) {
  _inherits(Modal, _PureComponent);

  function Modal(props) {
    _classCallCheck(this, Modal);

    var _this = _possibleConstructorReturn(this, (Modal.__proto__ || Object.getPrototypeOf(Modal)).call(this, props));

    _this.setRef = function (node) {
      _this.portalRef = node;
      _this.props.portalRef(node);
    };

    _this.handleKeyDown = function (event) {
      if (event.key === "Escape") _this.props.onEscKey();
    };

    _this.modalContainer = null;
    _this.ariaId = (0, _newId2.default)("modal-aria");
    return _this;
  }

  _createClass(Modal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      document.addEventListener("keydown", this.handleKeyDown, false);
      this.modalContainer = document.createElement("div");
      document.body.appendChild(this.modalContainer);
      this.renderModal();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.renderModal();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener("keydown", this.handleKeyDown);
      if (this.modalContainer) document.body.removeChild(this.modalContainer);
    }
  }, {
    key: "renderOverlay",
    value: function renderOverlay() {
      if (!this.props.hasOverlay) return null;
      return _react2.default.createElement("div", { className: "aclui-modal__overlay", onClick: this.props.onOverlayClick, tabIndex: "-1" });
    }
  }, {
    key: "renderModal",
    value: function renderModal() {
      var _props = this.props,
          ariaLabel = _props.ariaLabel,
          children = _props.children,
          className = _props.className,
          isOpen = _props.isOpen,
          width = _props.width,
          zIndex = _props.zIndex;

      var rootStyles = zIndex ? { zIndex: zIndex } : null;
      var rootClasses = (0, _classnames2.default)("aclui-modal", className, "" + widthOptions[width], {
        "aclui-modal--is-open": isOpen,
        "aclui-modal--is-scrollable": this.props.isScrollable
      });

      _reactDom2.default.render(_react2.default.createElement(
        "div",
        { className: rootClasses, style: rootStyles, onKeyDown: this.handleKeyDown, ref: this.setRef },
        this.renderOverlay(),
        _react2.default.createElement(
          "div",
          { className: "aclui-modal__content-frame" },
          _react2.default.createElement(
            "section",
            { className: "aclui-modal__content", role: "dialog", "aria-labelledby": this.ariaId },
            _react2.default.createElement(
              "span",
              { className: "aclui-modal__aria-label", id: this.ariaId },
              ariaLabel
            ),
            children
          )
        )
      ), this.modalContainer);
    }
  }, {
    key: "render",
    value: function render() {
      // Component will render in a portal element with renderModal()
      return null;
    }
  }]);

  return Modal;
}(_react.PureComponent);

Modal.propTypes = {
  /** Aria title of dialog for accessibility. */
  ariaLabel: _propTypes2.default.string.isRequired,

  /** Content for the Modal. */
  children: _propTypes2.default.node.isRequired,

  /** Custom classes for the root element of the Modal. */
  className: _propTypes2.default.string,

  /** If the Modal includes an overlay for content below it. */
  hasOverlay: _propTypes2.default.bool,

  /** Controls the visibility of the Modal. */
  isOpen: _propTypes2.default.bool,

  /** Function to call when "esc" key is pressed. */
  onEscKey: _propTypes2.default.func,

  /** Function to call when overlay is clicked. */
  onOverlayClick: _propTypes2.default.func,

  /** Exposes a reference to the Modal's portal element. */
  portalRef: _propTypes2.default.func,

  /** Makes the content of the modal scrollable, but as a side effect prevents any content (e.g. MultiSelects) from
  overflowing. If you need this on, you may want to consider using a different component instead of this one. */
  isScrollable: _propTypes2.default.bool,

  /** Width of the Modal. */
  width: _customPropTypes.shirtSize,

  /** Optional override of z-index. */
  zIndex: _propTypes2.default.number
};

Modal.defaultProps = {
  className: "",
  hasOverlay: true,
  isOpen: false,
  isScrollable: false,
  onEscKey: function onEscKey() {},
  onOverlayClick: function onOverlayClick() {},
  portalRef: function portalRef() {},
  width: "medium",
  zIndex: null
};

exports.default = Modal;